import React, {FC} from "react"
import {Col, Grid, Row} from "react-bootstrap"
import {CSSTransition} from "react-transition-group"

import FormattedMessage from "@irati/utils/lang"
import idHelper from "@irati/utils/id"
import {Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"

import {StyledDiv} from "./styled"

interface Props {
  id: string,
  show: boolean,
  onExit: () => void
}

const HomePagePopTart: FC<Props> = (props) => {
  const id = idHelper("pop-tart", props)
  const {show, onExit} = props

  return (
    <CSSTransition
      classNames="homepage-pop-tart"
      in={show}
      timeout={{
        enter: 300,
        exit: 300
      }}
      unmountOnExit>
      <StyledDiv id={id}>
        <Grid>
          <Row>
            <Col xs={12}>
              <Flex margin="10px 0" justifyContent="space-between" alignItems="center">
                <Flex alignItems="center">
                  <Body weight="semibold">
                    <FormattedMessage id="platform.homepage.popTart.title" />
                  </Body>
                  <Body small marginLeft={1}>
                    <FormattedMessage id="platform.homepage.popTart.text" />
                  </Body>
                </Flex>
                <Button primary onClick={onExit}>
                  <FormattedMessage id="platform.homepage.popTart.button" />
                </Button>
              </Flex>
            </Col>
          </Row>
        </Grid>
      </StyledDiv>
    </CSSTransition>
  )
}

export default HomePagePopTart
